export default "__VITE_ASSET__De3YuFxh__"